import React, { Component, PropTypes } from 'react';

import './MyoSelector.css';
import MyoSelectorItem from '../components/MyoSelectorItem';
import colors from '../colors';

class MyoSelector extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: this.props.selected
    }

    this._handleSelected = this._handleSelected.bind(this);
  }

  render() {
    let { data } = this.props;
    let { selected } = this.state;
    let style = Object.assign({}, this._getDefaultStyles(), this.props.style);

    return (
      <div className="myo-selector flex-column flex-justify-items" style={style}>
        <div className="flex-fill"></div>
        { data.map((myo) => {
          return <MyoSelectorItem key={myo.macAddress} data={myo}
                                  selected={selected.includes(myo)} onSelected={this._handleSelected} />;
        })}
        <div className="flex-fill"></div>
      </div>
    );
  }

  _getDefaultStyles() {
    let defaultStyle = {
      backgroundColor: colors.white,
    };

    return defaultStyle;
  }

  _handleSelected(item) {
    let { selected } = this.state;
    let remove = selected.includes(item);

    if (remove) {
      let index = selected.indexOf(item);
      selected.splice(index, 1);
    }
    else {
      selected.push(item);
    }

    this.props.onSelectionChanged(selected);
    this.setState({
      selected: selected
    });
  }
}

MyoSelector.propTypes = {
  style: PropTypes.object,
  data: PropTypes.array.isRequired,
  selected: PropTypes.array,
  onSelectionChanged: PropTypes.func
}

MyoSelector.defaultProps = {
  selected: [],
  onSelectionChanged: () => {}
}

export default MyoSelector;



/** WEBPACK FOOTER **
 ** ./src/components/MyoSelector.js
 **/